import {
  ChangeDetectorRef,
  Directive,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthStore } from '@store';

@Directive({
  selector: '[appHideForCompanyUser]',
})
export class HideForCompanyUserDirective implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authStore: AuthStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authStore
      .getCompanyName()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((companyName) => {
        this.updateView(!!companyName);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateView(isCompanyUser: boolean): void {
    if (isCompanyUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
    this.cdr.markForCheck();
  }
}
